import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

import { calculateDuration } from 'modules/attendance/lib/calculateDuration'
import { renderChange } from 'modules/attendance/lib/editTimesheetRequestsDisplay'
import { locationTypeText } from 'modules/attendance/lib/locationType'

interface UpdateShiftProps {
  minutes: number
  originalClockIn: string
  newClockIn?: string
  originalClockOut?: string
  newClockOut?: string
  originalLocationType?: string
  newLocationType?: string
  originalObservations?: string
  newObservations?: string
  originalBreakName?: string
  originalBreakPaid?: boolean
  originalBreakId?: number
  newIsBreak: boolean
  newBreakName?: string
  newBreakPaid?: boolean
  newBreakId?: number
  employeeName: string
  date: string
}

const UpdateShiftBlock = ({
  minutes,
  originalClockIn,
  newClockIn,
  originalClockOut,
  newClockOut,
  originalLocationType,
  newLocationType,
  originalObservations,
  newObservations,
  originalBreakId,
  originalBreakName,
  originalBreakPaid,
  newBreakId,
  newIsBreak,
  newBreakName,
  newBreakPaid,
  employeeName,
  date,
}: UpdateShiftProps) => {
  const originalDuration =
    originalClockIn && originalClockOut
      ? calculateDuration(originalClockIn, originalClockOut)
      : { hours: 0, minutes: 0 }

  const newDuration =
    (newClockIn || originalClockIn) && (newClockOut || originalClockOut)
      ? calculateDuration(newClockIn || originalClockIn, newClockOut || originalClockOut!)
      : { hours: 0, minutes: 0 }
  const workedTime = minutesToText(minutes)

  return (
    <>
      <Box gap="s8" paddingLeft="s16">
        <ul>
          {renderChange(
            i18n.t('dashboard.todo.approvals.attendance.clock_in'),
            'grey1000',
            originalClockIn,
            newClockIn
          )}
          {renderChange(
            i18n.t('dashboard.todo.approvals.attendance.clock_out'),
            'grey1000',
            originalClockOut,
            newClockOut
          )}
          {renderChange(
            i18n.t('dashboard.todo.approvals.attendance.location_type'),
            'grey1000',
            originalLocationType && locationTypeText(originalLocationType),
            newLocationType && locationTypeText(newLocationType)
          )}
          {renderChange(
            i18n.t('dashboard.todo.approvals.attendance.observations'),
            'grey1000',
            originalObservations,
            newObservations
          )}
          {newIsBreak && newBreakId !== originalBreakId && (
            <li key={'break'} style={{ listStyleType: 'disc' }}>
              <Text.Normal weight="bold">
                {i18n.t('dashboard.todo.approvals.attendance.break')}
              </Text.Normal>
              <Box flexDirection="row" alignItems="center">
                <Box width="fit-content" padding="s4">
                  <Tag type={originalBreakPaid ? Tag.Types.lime : Tag.Types.malibu}>
                    {originalBreakName}
                  </Tag>
                </Box>
                <Text.Normal>{'->'}</Text.Normal>
                <Box width="fit-content" padding="s4">
                  <Tag type={newBreakPaid ? Tag.Types.lime : Tag.Types.malibu}>{newBreakName}</Tag>
                </Box>
              </Box>
            </li>
          )}
        </ul>
      </Box>

      <Box
        background="viridian200"
        paddingX="s16"
        paddingY="s24"
        borderRadius={{ all: 'abs012' }}
        gap="s8"
      >
        <Text size="200">
          {i18n.t('dashboard.todo.approvals.attendance.duration_change', {
            employee: employeeName ?? '',
            date: dateToString(moment(date ? String(date) : ''), 'ui_abbreviated_month_year'),
            original_duration_hours: originalDuration.hours,
            original_duration_minutes: originalDuration.minutes,
            new_duration_hours: newDuration.hours,
            new_duration_minutes: newDuration.minutes,
          })}
        </Text>
        <Text size="200">
          {i18n.t('dashboard.todo.approvals.attendance.worked_time', { workedTime })}
        </Text>
      </Box>
    </>
  )
}

export default UpdateShiftBlock
